import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";

import { Page } from "../../../_partials/Layout";
import NavBar from '../../../../componets/NavBar';

interface PropsInterface {
  children: React.ReactNode;
  className?: string;
}

const PageLayout: React.FunctionComponent<PropsInterface> = (props: PropsInterface) => {
  const location = useLocation();
  const { pathname } = location;

  const navBarItems = [
    {
      name: 'Assets',
      icon: 'list',
      url: '/cartoondraw'
    },
    {
      name: 'Popular',
      icon: 'fire',
      url: '/cartoondraw/popular'
    },
    {
      name: 'Banners',
      icon: 'ad',
      url: '/cartoondraw/banners'
    },
    {
      name: 'Reports',
      icon: 'exclamation-triangle',
      url: '/cartoondraw/reports'
    }
  ];

  const [activeNav, setActiveNav] = useState<number>(0);

  useEffect(() => {
    const navIndex = navBarItems.findIndex(item => pathname === item.url);
    setActiveNav(navIndex);
  }, [pathname]);

  return (
    <Page className={props.className}>
      <NavBar items={navBarItems} activeIndex={activeNav} />

      <div className='v-layout--body'>
        {props.children}
      </div>
    </Page>
  );
}

export default PageLayout;
